import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";

// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
import agent from "../../agent";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";


import "./ManageXero.css";

import { Grid, Typography, Button, TextField, IconButton, Paper, Tabs, Tab, Hidden, MenuItem } from "@material-ui/core";

import InputAdornment from "@material-ui/core/InputAdornment";
import Heading from "../../components/Heading";
import  Loading from "../../components/loadingSpinner/Loading";

import ConnectedAccount from "../xero/ConnectedAccount";
import InvoiceMapping from "../xero/InvoiceMapping";
import ContactMapping from "../xero/ContactMapping";
import EmployeeMapping from "../xero/EmployeeMapping";

import SyncXero from "../xero/SyncXero";
import XeroLog from "../xero/XeroLog";
import SuperAnnuationSettings from "../xero/SuperAnnuationSettings"


import { ProfileType } from "../../types/enum";

@inject("profileStore", "templateStore", "userStore", "authStore", "billingStore","googleCalendarStore","xeroStore")
@withRouter
@observer
class ManageXero extends Component {
    state = {
        firstName: "",
        lastName: "",
        email: "",
        passwordEditState: false,
        isDirty: false,
        password: "",
        newPassword: "",
        confirmPassword: "",
        showPassword: false,
        isPrivateHireLock: false,
        tab: 0,
        tabDisabled: false,
        isLoading: false,
        isRedirected: false
    };

    handleLoading = (value) => {
        this.setState({ isLoading: value });
    };
    componentDidMount() {

        this.props.userStore.getUserCognito()
        this.props.googleCalendarStore.setGoogleCalendarCode("");
        const { currentUser } = this.props.userStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.setState({
            firstName: currentUser.given_name,
            lastName: currentUser.family_name,
            email: currentUser.email,
            firstNameEditState: false,
            lastNameEditState: false,
            emailEditState: false,
            passwordEditState: false,
            isDirty: false,
            password: "",
            newPassword: "",
            confirmPassword: "",
            showPassword: false
        });

        if (this.props?.match?.params?.activeTab) {
            const activeTab = this.props.match.params.activeTab;
            if (activeTab === "soleTraderMapping" || activeTab === "employeeMapping") {
                this.setState({ tab: 5 });
            } else if (activeTab === "invoiceMapping") {
                this.setState({ tab: 1 });
            } else if (activeTab === "contactMapping") {
                this.setState({ tab: 2 });
            } else if (activeTab === "sync") {
                this.setState({ tab: 3 });
            } else if (activeTab === "log") {
                this.setState({ tab: 6 });
            }
        }

        // if (this.props && this.props.match && this.props.match.params && this.props.match.params.tab) {
        //     if (this.props.match.params.tab === "integration") {
        //         this.setState({
        //             tab: 1
        //         });
        //     }
       
        //     if (this.props.match.params.tab === "lock") {
        //         this.setState({ tab: 3, tabDisabled: true });
        //     }
        //     if(this.props.match.params.tab === "privatehirelock"){
        //         this.setState({ tab: 3, tabDisabled: true,isPrivateHireLock: true });
        //     }
        //     if(this.props.match.params.tab === "contactadministrator"){
        //         this.setState({ isRedirected : true, tabDisabled: true});
        //     }
        //     if(this.props.match.params.tab === "Xero"){
        //         const query = new URLSearchParams(this.props.location.search);
        //         const token = query.get('code')
               
        //         if(token){
        //             var codeXero = decodeURIComponent(token)
        //             this.props.xeroStore.setXeroCode(token);
        //             const body = {
        //                 code: codeXero
        //             };
        //             this.setState({
        //                 isLoading: true,
                        
        //             });
        //             this.props.xeroStore.connectXero(currentProfile.id, body).then(result => {
        //                 this.props.profileStore.loadProfiles().finally(() => {
        //                     this.setState({
        //                         isLoading: true,
        //                         tab: 5
        //                     });
        //                 })
        //             })
        //             // return agent.Xero.authorizeXero(body).then(result => {
        //             //     console.log("diceritakan", result)
        //             // });
        //         }else{
        //             this.setState({ tab: 5});
        //         }
              
        //     }
        //     if(this.props.match.params.tab === "googlecalendar"){
        //         const query = new URLSearchParams(this.props.location.search);
        //         const token = query.get('code')
        //         this.props.googleCalendarStore.setGoogleCalendarCode(token);
        //         this.setState({ tab: 5});
        //     }
        // }
        this.props.authStore.setPassword("");
        this.props.authStore.setNewPassword("");
        this.props.authStore.setConfirmPassword("");
    };

    handleChangeTab = (event, value) => {
        this.setState({ tab: value });
    };

    redirectToInvoiceMapping = () => {
        this.setState({
            tab: 1
        });
    }
    handleSelectedTab = (event, value) => {
        this.setState({ tab: value });
    };
    handleSelectChange = event => {
        this.setState({ tab:  event.target.value });
       
    }
    
    render() {
        const { currentProfileType } = this.props.profileStore;
        const { billingAccess } = this.props.billingStore; 
        
        return (
            <div>
                <Header role={this.props.templateStore.getTypeString(currentProfileType || 1)} />
                <Loading showed={this.state.isLoading}/>
                <Sidebar />
                <MainContainer>
                    <Heading title="Xero Settings" />
                    
                    <Paper style={{ position: "relative", borderRadius: 12 }}>
                        {
                            process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" &&
                                <Grid item xs={12} lg={12}>
                                    <Hidden smDown>
                                                                                <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                            <Tabs 
                                                value={this.state.tab} 
                                                onChange={this.handleChangeTab}  
                                                indicatorColor="primary" 
                                                textColor="secondary"
                                                scrollable
                                                scrollButtons="off"
                                                classes={{
                                                    root: "tabs-root",
                                                    indicator: "tabs-indicator"
                                                }}
                                            >
                                                <Tab label="Connected Account" classes={{ selected: "tab-selected" }} />
                                                <Tab label="Invoice Mapping" classes={{ selected: "tab-selected" }} />
                                                <Tab label="Contact Mapping" classes={{ selected: "tab-selected" }} />
                                                <Tab label="Sync" classes={{ selected: "tab-selected" }} />
                                                <Tab label="SuperAnnuation Settings" classes={{ selected: "tab-selected" }}/>
                                                <Tab label="Sole Trader Payroll Mapping" classes={{ selected: "tab-selected" }}/>
                                                <Tab label="Log" classes={{ selected: "tab-selected" }} />
                                            </Tabs>
                                        </AppBar>

                                        {/* <Tabs value={this.state.tab} onChange={this.handleChangeTab}  indicatorColor="primary" textColor="primary">
                                                <Tab label="Connected Account"/>
                                                <Tab label="Invoice Mapping"/>
                                                <Tab label="Contact Mapping"/>
                                                <Tab label="Sync"/>
                                                <Tab label="SuperAnnuation Settings"/>
                                                <Tab label="Sole Trader Payroll Mapping"/>
                                                <Tab label="Log"/>
                                        </Tabs> */}
                                       
                                        <br />
                                    </Hidden>
                                    <Hidden mdUp>
                                        <div style={{ padding: 8 }}>
                                        <TextField select value={this.state.tab} onChange={this.handleSelectChange} textColor="primary" fullWidth>
                                                <MenuItem key={0} value={0}>
                                                    Connected Account
                                                </MenuItem>
                                                <MenuItem key={1} value={1}>
                                                    Invoice Mapping
                                                </MenuItem>
                                                <MenuItem key={2} value={2}>
                                                    Contact Mapping
                                                </MenuItem>
                                                <MenuItem key={3} value={3}>
                                                    Sync
                                                </MenuItem>
                                                <MenuItem key={4} value={4}>
                                                    SuperAnnuationn Settings
                                                </MenuItem>
                                                <MenuItem key={5} value={5}>
                                                    Sole Trader Payroll Mapping
                                                </MenuItem>
                                                <MenuItem key={6} value={6}>
                                                    Log
                                                </MenuItem>
                                                {/* <MenuItem key={5} value={5}>
                                                    Error Log
                                                </MenuItem> */}
                                            </TextField>
                                           
                                        </div>
                                    </Hidden>
                                    <div className="xero-settings-content">
                                                {this.state.tab === 0 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Connected Account</Typography>
                                                            <Typography className="xero-section-description">Manage your Xero account connection and organization settings.</Typography>
                                                        </div>
                                                        <ConnectedAccount />
                                                    </div>
                                                )}
                                                {this.state.tab === 1 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Invoice Mapping</Typography>
                                                            <Typography className="xero-section-description">Configure how invoices are mapped between Hot Giggity and Xero.</Typography>
                                                        </div>
                                                        <InvoiceMapping />
                                                    </div>
                                                )}
                                                {this.state.tab === 2 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Contact Mapping</Typography>
                                                            <Typography className="xero-section-description">Configure how contacts are synced between Hot Giggity and Xero.</Typography>
                                                        </div>
                                                        <ContactMapping />
                                                    </div>
                                                )}
                                                {this.state.tab === 3 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Sync Settings</Typography>
                                                            <Typography className="xero-section-description">Configure and trigger synchronization with your Xero account.</Typography>
                                                        </div>
                                                        <SyncXero />
                                                    </div>
                                                )}

                                                {this.state.tab === 4 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Sync Log</Typography>
                                                            <Typography className="xero-section-description">Configure of synchronization activities with Xero super ledger.</Typography>
                                                        </div>
                                                        <SuperAnnuationSettings/>
                                                    </div>
                                                )}

                                                {this.state.tab === 5 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Sole Trader Artist Mapping</Typography>
                                                            <Typography className="xero-section-description">Map your Hot Giggity sole trader artists to their Xero employee records.</Typography>
                                                        </div>
                                                        <EmployeeMapping/>
                                                    </div>
                                                )}
                                              
                                                {this.state.tab === 6 && (
                                                    <div>
                                                        <div className="xero-section-header">
                                                            <Typography variant="headline" component="h2" className="xero-section-title">Sync Log</Typography>
                                                            <Typography className="xero-section-description">View the history of synchronization activities with Xero.</Typography>
                                                        </div>
                                                        <XeroLog redirectToInvoiceMapping={this.redirectToInvoiceMapping}/>
                                                    </div>
                                                )}

                                    </div>
                                </Grid>
                         }
                    </Paper>
                </MainContainer>
            </div>
        );
    }
}

export default ManageXero;
